// extracted by mini-css-extract-plugin
module.exports = {"grid":"GlobalUspSmallGroup_grid__E8w5I"};